package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.about.AboutPage
import org.moxultimate.topwithmox.components.layouts.PageLayoutData

/**
 * initAboutRoute
 * Registers page layout data for the /about route.
 *
 * @param ctx Kobweb route initialisation context.
 */
@InitRoute
fun initAboutRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("About"))
}

/**
 * AboutRoute
 * Kobweb page entry point for the /about route — renders [AboutPage].
 */
@Page(routeOverride = "about")
@Layout(".components.layouts.PageLayout")
@Composable
fun AboutRoute() {
    AboutPage()
}
